module.exports = __webpack_public_path__ + "static/media/dice.fb365a86.svg";